











import { Component, Vue, Watch } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class AdminRegisterLayoutIframe extends Vue {
  private remoteSrc = '';

  @Watch('$route.params.type')
  private setRemoteSrc() {
    const { params: { type }, query } = this.$route;
    const queryString = new URLSearchParams(query as Record<string, string>).toString();
    const postfix = type ? `/${type}` : '';
    this.remoteSrc = `${process.env.VUE_APP_ADMIN_REMOTE_URL}/configuration/management/application${postfix}?${queryString}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
